/**
 * PageHeader Component
 * Consistent page header with breadcrumbs, title, and optional actions
 * Part of Custom UI Framework
 */

import React from 'react';
import { Typography, Space, Divider } from 'antd';
import Breadcrumbs from './Breadcrumbs';

const { Title } = Typography;

/**
 * PageHeader Component
 *
 * @param {string} title - Page title
 * @param {Array} breadcrumbs - Breadcrumb items [{label, path}]
 * @param {ReactNode} actions - Action buttons/elements to display on right
 * @param {ReactNode} extra - Additional content below title
 * @param {boolean} showBreadcrumbs - Show breadcrumbs (default: true)
 * @param {boolean} showDivider - Show divider below header (default: true)
 * @param {Object} style - Additional styles
 */
function PageHeader({
  title,
  breadcrumbs = [],
  actions,
  extra,
  showBreadcrumbs = true,
  showDivider = true,
  style = {},
}) {
  return (
    <div style={{ marginBottom: showDivider ? '24px' : '16px', ...style }}>
      {showBreadcrumbs && breadcrumbs.length > 0 && (
        <Breadcrumbs
          items={breadcrumbs}
          style={{ marginBottom: '12px' }}
        />
      )}

      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: extra ? '12px' : '0',
      }}>
        <Title
          level={2}
          style={{
            margin: 0,
            color: '#17052B',
            fontSize: '24px',
            fontWeight: 600,
          }}
        >
          {title}
        </Title>

        {actions && (
          <Space size="middle">
            {actions}
          </Space>
        )}
      </div>

      {extra && (
        <div style={{ marginTop: '12px' }}>
          {extra}
        </div>
      )}

      {showDivider && (
        <Divider style={{ margin: '16px 0 24px 0' }} />
      )}
    </div>
  );
}

export default PageHeader;
